import SlotWithEvolutionValue from "@/components/tableElements/SlotWithEvolutionValue.vue";
import LayeredBarWithValue from "@/components/tableElements/LayeredBarWithValue.vue";
import VariableStyledBar from "@/components/tableElements/VariableStyledBar.vue";
import HugValue from "@/components/tableElements/HugValue.vue";
export default {
  name: 'BsrEvolutionBarWithValue',
  props: {
    value: {
      type: [Number, null]
    },
    min: Number,
    max: Number,
    loading: Boolean
  },
  data() {
    return {
      color1: "#E3E3E3",
      color2: "linear-gradient(to left, #8D85E5, #C5C0F9)"
    };
  },
  computed: {
    transformedValue() {
      return this.max - this.value;
    }
  },
  components: {
    SlotWithEvolutionValue,
    LayeredBarWithValue,
    VariableStyledBar,
    HugValue
  }
};